import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";

import TradePaymentComplete from "./TradePaymentComplete";
import { DollarIcon } from "../../../../assets/icons/iconsProvider";
import CustomerImage from "../../../../assets/images/customerImage.svg";
import AddNewCustomerModal from "../../NewTransaction/AddNewCustomer/AddNewCustomerModal";
import { printReceiptData } from "../../../../shared/Printers/ReceiptPrinters/printReceipt";
import TradePrintLabelModal from "../../../Inventory/Items/printingLabelModal/TradePrintLabelModal";
import { handleOpenCashDrawer } from "../../../../shared/Printers/ReceiptPrinters/prepareReceiptForPrinter";
import { prepareReceiptForPrinterTrade } from "../../../../shared/Printers/ReceiptPrinters/prepareReceiptForPrinterTrade";
import ConfirmationModal from "../../../../views/Inventory/Items/ConfirmationModal/ConfirmationModal";
import {
  outletActions,
  systemActions,
  transactionActions,
} from "../../../../redux/actions";
import {
  Topbar,
  Button,
  CustomerDropdown,
  SimpleNumberField,
  SelectedCustomerCard,
  ProductNameOnPaymentScreen,
} from "../../../../shared/components";
import {
  toastType,
  toastMessages,
  globalConstants,
  routesPathConstants,
  buttonNameConstants,
  buttonTypeConstants,
  transactionConstants,
  categoryDropdownConstants,
  tradeTransactionDefaultData,
  SALE_TRANSACTION_ACTIVITY_TYPES,
  toggleSwitchButtonConstants,
} from "../../../../constants";
import {
  customToast,
  parseToNumber,
  getShortestSku,
  handlePayClick,
  parseJsonObject,
  stringifyObject,
  splitCalculation,
  checkIsOutletOpen,
  getReceiptPrintDate,
  getUnitPurchasePrice,
  getCurrentMacAddress,
  parseToDecimalNumber,
  createCompanyDynamicUrl,
  getTradeTransactionDetails,
  handleTradeTransactionData,
  getPurchasePriceForTradeItem,
  getProductLabelNotifications,
  getSessionIdForSaleTradePayload,
  getPurchasePriceAfterSplitValueChange,
  parseToThousandSeperatorDecimalNumber,
  getOutletRelationObjectForSaleTradePayload,
  isTradeInProgress,
} from "../../../../shared/utility";

const NewTradePayment = (props) => {
  //------ props
  const {
    user,
    outlet,
    printer,
    customer,
    transaction,
    newTradePark,
    spinnerArray,
    currentStore,
    sendEmailOrSMS,
    activateSpinner,
    setNewTradeData,
    tradeTransaction,
    deactivateSpinner,
    userNotifications,
    isAddCustomerModal,
    getOutletByMacAddress,
    toggleAddCustomerModal,
    addTradeBatchInventory,
  } = props;

  const navigate = useNavigate();
  const { state } = useLocation();
  //------ reducers
  const { allCustomers } = customer;
  const { newTradeData } = transaction;
  const { defaultReceiptPrinter } = printer;
  const { PaymentType, inventory } = newTradeData;
  const { currentOutlet, currentSessionId } = outlet;
  const cartItems = inventory;

  //------ constants
  const splitAmounts = newTradeData.splitAmounts;
  const isCashPayment = PaymentType === transactionConstants.CASH;
  const isSplitPayment =
    newTradeData?.isSplitPayment === undefined
      ? false
      : newTradeData?.isSplitPayment;

  //------ useState
  const [isConsent, setIsConsent] = useState(false);
  const [isOtherPayment, setIsOtherPayment] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [customerToEdit, setCustomerToEdit] = useState({});
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  let cartItemsCount = useRef(newTradeData?.inventory?.length ?? 0);
  const [selectedCustomerFlag, setSelectedCustomerFlag] = useState(false);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [labelNotifications, setLabelNotifications] = useState([]);

  //-------Toggle Print Label Modal
  const togglePrintLabelModal = () => {
    setPrintLabelModal(!printLabelModal);
  };

  const updateTradeData = (data, activityName) => {
    handleTradeTransactionData(
      data,
      user,
      currentStore,
      activityName,
      newTradeData,
      setNewTradeData
    );
  };

  //-------Toggle Print Product Labels and Set products to be printed
  const handlePrintLabelModal = () => {
    setSelectedRows([]);
    const labelPrintProducts = getProductLabelNotifications(userNotifications);

    setLabelNotifications(labelPrintProducts[0] ? [labelPrintProducts[0]] : []);

    const reversedArray = labelPrintProducts;
    setSelectedRows(
      reversedArray[0]?.products.map((item) => {
        const newObject = {
          sku: item.sku,
          product_name: item.product_name,
          price: {
            quantity: item?.price?.quantity,
            type: item?.price?.type,
            unit_sell_price: item?.price?.unit_sell_price,
            dbQuantity: item.price.dbQuantity,
            isPriceChanged: item.price.isPriceChanged,
            isProductExisted: item.price.isProductExisted,
            quantityAdded: item.price.quantityAdded,
          },
          category_name: item?.category_name,
          productType: item?.productType,
          tags: item?.tags,
        };
        return newObject;
      })
    );
    togglePrintLabelModal();
  };

  //-------handle calculate number of items in cart
  const calculateItems = () => {
    if (Array.isArray(cartItems) && cartItems.length > 0) {
      return cartItems.reduce((acc, item) => {
        const quantity = Number(item?.price?.quantity) || 0;
        const onlineQuantity = Number(item?.price?.onlineQuantity) || 0;
        return acc + quantity + onlineQuantity;
      }, 0);
    }
    return 0;
  };

  //------ handle customer edit
  const handleCustomerEditClick = () => {
    const customer = allCustomers?.find(
      (customer) => customer.id === newTradeData?.customer?.id
    );
    if (customer?.id) {
      setCustomerToEdit(customer);
      toggleAddCustomerModal(true);
    }
  };

  //-------cancel split payout
  const handleCancelSplitPayout = () => {
    const { inventory } = newTradeData;

    //------on cancel split recalculate purchase price
    const updatedInventory = inventory?.map((item) => ({
      ...item,
      price: {
        ...item.price,
        unit_purchase_price:
          isCashPayment || isOtherPayment ? item.cashOffer : item.tradeOffer,
      },
    }));

    //-------Total Amount to pay after calculation
    const totalAmount = splitCalculation(
      0,
      isCashPayment || isOtherPayment,
      newTradeData
    );

    //-------update trade data
    updateTradeData(
      {
        ...newTradeData,
        SubTotal: totalAmount,
        amountToPay: totalAmount,
        inventory: updatedInventory,
        totalAmountToPay: totalAmount,
        currentAmountToPay: totalAmount,
        isSplitPayment: !isSplitPayment,
        splitAmounts: {
          ...splitAmounts,
          cashAmount: 0,
          tradeAmount: 0,
          splitAmount: 0,
          otherSplitAmount: totalAmount,
          originalAmountToPay: totalAmount,
        },
      },

      SALE_TRANSACTION_ACTIVITY_TYPES.TRADE_SPLIT_PAYMENT
    );
  };

  const handleSplitValueChange = (
    value,
    splitKey = "splitAmount",
    isOtherSplit = false
  ) => {
    const isCashOrOtherPayment = isCashPayment || isOtherPayment;
    const currentValue = newTradeData?.splitAmounts?.[splitKey];

    // Value didn't change
    if (Number(value) === Number(currentValue)) {
      updateTradeData(
        {
          ...newTradeData,
          splitAmounts: {
            ...splitAmounts,
            [splitKey]: value,
          },
        },
        SALE_TRANSACTION_ACTIVITY_TYPES.SPLIT_AMOUNT
      );
      return;
    }

    // Calculate opposite split value
    const valueAfterCalculation = splitCalculation(
      value,
      isCashOrOtherPayment,
      newTradeData,
      isOtherSplit
    );

    // Calculate purchase price after split value change
    const updatedInventory = getPurchasePriceAfterSplitValueChange(
      isCashOrOtherPayment
        ? isOtherSplit
          ? value
          : valueAfterCalculation
        : isOtherSplit
        ? valueAfterCalculation
        : value,
      isCashOrOtherPayment
        ? isOtherSplit
          ? valueAfterCalculation
          : value
        : isOtherSplit
        ? value
        : valueAfterCalculation,
      newTradeData?.inventory
    );

    // Calculate total amount to pay
    const totalAmount = newTradeData?.isSplitPayment
      ? parseToNumber(Number(valueAfterCalculation) + Number(value))
      : newTradeData?.totalAmountToPay;

    // Calculate cash amount to pay
    const cashAmount = isCashOrOtherPayment
      ? isOtherSplit
        ? value
        : parseToDecimalNumber(valueAfterCalculation)
      : isOtherSplit
      ? parseToDecimalNumber(valueAfterCalculation)
      : value;

    // Calculate trade amount to pay
    const tradeAmount = isCashOrOtherPayment
      ? isOtherSplit
        ? parseToDecimalNumber(valueAfterCalculation)
        : value
      : isOtherSplit
      ? value
      : parseToDecimalNumber(valueAfterCalculation);

    updateTradeData(
      {
        ...newTradeData,
        SubTotal: totalAmount,
        inventory: updatedInventory,
        amountToPay: totalAmount,
        totalAmountToPay: totalAmount,
        currentAmountToPay: totalAmount,

        splitAmounts: {
          ...splitAmounts,
          cashAmount,
          tradeAmount,
          [splitKey]: value,

          ...(isOtherSplit
            ? {
                splitAmount: parseToDecimalNumber(valueAfterCalculation),
              }
            : {
                otherSplitAmount: parseToDecimalNumber(valueAfterCalculation),
                originalAmountToPay: parseToDecimalNumber(
                  valueAfterCalculation
                ),
              }),
        },
      },
      SALE_TRANSACTION_ACTIVITY_TYPES.SPLIT_AMOUNT
    );
  };

  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  const handleConfirmYesButtonClick = () => {
    addTradeTransaction();
    toggleConfirmationModal();
  };

  const submitAddTradeTransaction = async () => {
    if (isOtherPayment) {
      toggleConfirmationModal();
    } else {
      addTradeTransaction();
    }
  };
  const addTradeTransaction = async () => {
    //-------if outlet is not open or register is not open
    //------- then it will not allow to make transaction
    //------- and draft that trade trnasaction
    if (
      checkIsOutletOpen(
        navigate,
        routesPathConstants.SELL_AND_TRADE_NEW_TRADE,
        currentStore,
        getCurrentMacAddress,
        getOutletByMacAddress
      )
    ) {
      handlePayClick(
        transactionConstants.DRAFT,
        currentStore,
        newTradeData,
        cartItemsCount,
        addTradeBatchInventory,
        outlet,
        newTradePark,
        navigate,
        () => {},
        updateTradeData,
        transactionActions,
        user
      );
      return;
    }
    //-------if payment type is split or store credit then check if customer is selected or not
    if (
      ((!isCashPayment && !isOtherPayment) || isSplitPayment) &&
      (!newTradeData?.customer?.id || newTradeData?.customer === "")
    ) {
      customToast(toastMessages.PLEASE_SELECT_A_CUSTOMER, toastType.ERROR);
      return;
    }

    let paymentType = isCashPayment
      ? isOtherPayment
        ? transactionConstants.OTHER
        : transactionConstants.CASH
      : transactionConstants.STORE_CREDIT;

    const { cashAmount, tradeAmount } = newTradeData.splitAmounts;

    //-------set payment type
    if (!(Number(cashAmount) === 0 && Number(tradeAmount) === 0)) {
      paymentType = isSplitPayment ? transactionConstants.SPLIT : paymentType;
    }

    //------ prepare data to send for trade transaction
    const dataToSend = {
      ...(await getTradeTransactionDetails(
        newTradeData,
        isConsent,
        paymentType,
        activateSpinner,
        transactionConstants.PROCESSED,
        deactivateSpinner,
        isOtherPayment
      )),
      outlet: getOutletRelationObjectForSaleTradePayload(
        currentStore,
        currentOutlet
      ),
      sessionId: getSessionIdForSaleTradePayload(
        currentStore,
        currentOutlet,
        currentSessionId
      ),
    };

    tradeTransaction(
      dataToSend,
      currentStore?.companyId,
      newTradeData,
      updateTradeData,
      handlePrintReceipt,
      currentStore[toggleSwitchButtonConstants.IS_AUTO_PRINT_TRADE_RECEIPT],
      handleOpenCashDrawer,
      defaultReceiptPrinter
    );
  };

  function getBackNavigation() {
    handleShowDraftModal();
    const historyCheck =
      (newTradeData?.paymentHistory?.totalPaidAmount[
        transactionConstants.CASH
      ] || 0) +
        (newTradeData?.paymentHistory?.totalPaidAmount[
          transactionConstants.STORE_CREDIT
        ] || 0) +
        (newTradeData?.paymentHistory?.totalPaidAmount[
          transactionConstants.OTHER
        ] || 0) >
      0
        ? true
        : false;
    if (historyCheck) {
      navigate(
        createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_TRADE)
      );
      updateTradeData(
        tradeTransactionDefaultData,
        SALE_TRANSACTION_ACTIVITY_TYPES.RESET_TRANSACTION
      );
    } else {
      navigate(
        createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_TRADE)
      );
    }
  }
  const handleAddCustomerClick = (customerToEdit = {}) => {
    setCustomerToEdit(customerToEdit);
    toggleAddCustomerModal(true);
  };

  const handleShowDraftModal = () => {
    // handle component unmounting
    cartItemsCount.current = 0;
  };

  const handlePrintReceipt = (newTradeData, giftReceipt) => {
    const partialPayment =
      (newTradeData?.paymentHistory?.totalPaidAmount[
        transactionConstants.CASH
      ] || 0) +
        (newTradeData?.paymentHistory?.totalPaidAmount[
          transactionConstants.STORE_CREDIT
        ] || 0) +
        (newTradeData?.paymentHistory?.totalPaidAmount[
          transactionConstants.OTHER
        ] || 0) >
        0 &&
      newTradeData?.totalAmountToPay !== newTradeData?.currentAmountToPay;
    const printData = prepareReceiptForPrinterTrade(
      user,
      newTradeData?.id,
      newTradeData?.paymentHistory,
      currentStore,
      newTradeData?.customer,
      [
        ...newTradeData?.inventory.map((inv) => {
          return {
            ...inv,
            cogs: inv?.price?.unit_purchase_price,
            item: inv?.product_name,
            priceAfterDiscount: partialPayment
              ? getUnitPurchasePrice(newTradeData, inv)
              : inv?.price?.unit_purchase_price,
            itemName: inv?.product_name,
            quantity: inv?.price?.quantity,
            productType: inv?.productType,
            category: inv?.category_name,
            actualPrice: partialPayment
              ? getUnitPurchasePrice(newTradeData, inv)
              : inv?.price?.unit_purchase_price,
          };
        }),
      ],
      newTradeData?.discount,
      newTradeData?.SubTotal,
      newTradeData?.tax,
      newTradeData?.totalAmountToPay,
      0,
      0,
      true,
      partialPayment,
      giftReceipt,
      getReceiptPrintDate(newTradeData.createdOn)
    );
    printReceiptData(printData, defaultReceiptPrinter);
  };
  const selectedCustomer = (selectedCustomerFlag) => {
    setSelectedCustomerFlag(selectedCustomerFlag);
  };

  useEffect(() => {
    if (allCustomers && allCustomers.length > 0 && selectedCustomerFlag) {
      updateTradeData(
        {
          ...newTradeData,
          customer: {
            ...allCustomers[0],
            name: allCustomers[0].firstName + " " + allCustomers[0].lastName,
          },
        },
        SALE_TRANSACTION_ACTIVITY_TYPES.ADD_CUSTOMER
      );
      setSelectedCustomerFlag(false);
    } // eslint-disable-next-line
  }, [allCustomers]);

  useEffect(() => {
    if (!newTradeData) {
      navigate(
        createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_TRADE)
      );
    } // eslint-disable-next-line
  }, [newTradeData]);
  useEffect(() => {
    setAddCustomerModal(isAddCustomerModal);
  }, [isAddCustomerModal]);

  // // handle component unmounting
  // useEffect(() => {
  //   return () => {
  //     if (cartItemsCount.current > 0) {
  //       handleDraftModal(transactionConstants.TRADE_DRAFT_MODAL);
  //     }
  //   }; // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if (newTradeData?.paymentMethod === transactionConstants.PAYMENT_COMPLETE) {
      handleShowDraftModal();
    } // eslint-disable-next-line
  }, [newTradeData.paymentMethod]);

  useEffect(() => {
    if (state.currentStore.id !== currentStore.id) {
      handleShowDraftModal();
      updateTradeData(
        tradeTransactionDefaultData,
        SALE_TRANSACTION_ACTIVITY_TYPES.RESET_TRANSACTION
      );
      navigate(
        createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_TRADE)
      );
    } // eslint-disable-next-line
  }, [currentStore]);

  const toggleIsOtherPayment = (value) => {
    setIsOtherPayment(value);
  };

  return (
    <>
      <Topbar
        title="Payment"
        isNewSalePayment={true}
        totalCartItems={cartItems?.length || 0}
        exportButton={
          newTradeData?.paymentMethod ===
            transactionConstants.PAYMENT_COMPLETE &&
          !(
            newTradeData?.inventory?.length === 1 &&
            newTradeData?.inventory[0]?.product_id ===
              transactionConstants.QUICK_TRADE
          )
        }
        buttonType={buttonTypeConstants.LIGHT_PURPLE}
        label={buttonNameConstants.PRINT_PRODUCT_LABEL}
        handleClick={handlePrintLabelModal}
      />
      <Row className="m-0">
        <Col md={6} className="payment-cart-wrapper container-scrollbar">
          <div className="payment-cart">
            <div className="">
              {cartItems?.map((cartItem, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center w-100 mt-1 "
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="opacity-75">
                      {cartItem?.isSeparateQuantity
                        ? cartItem?.price?.onlineQuantity
                        : cartItem?.price?.quantity}{" "}
                      x
                    </span>
                    <ProductNameOnPaymentScreen
                      productName={cartItem.product_name}
                    />
                    <span className="opacity-50">
                      {!cartItem.sku.includes(
                        transactionConstants.QUICK_TRADE
                      ) &&
                        (cartItem.sku.includes(transactionConstants.BATCH_TRADE)
                          ? "Auto Generated"
                          : `#${getShortestSku(cartItem.sku)}`)}
                    </span>
                  </div>
                  <span className="payment-cart-productname">
                    $
                    {parseToThousandSeperatorDecimalNumber(
                      getPurchasePriceForTradeItem(
                        isSplitPayment,
                        isCashPayment || isOtherPayment,
                        cartItem
                      )
                    )}
                  </span>
                </div>
              ))}
            </div>

            <hr />
            <div className="d-flex justify-content-between align-items-center w-100 mt-4">
              <div className="d-flex align-items-center gap-2">
                <span className="subtotal-heading">SALE TOTAL</span>
                <span>{calculateItems()} Items</span>
              </div>
              <span className="payment-cart-productname">
                ${" "}
                {parseToThousandSeperatorDecimalNumber(
                  newTradeData?.totalAmountToPay
                )}
              </span>
            </div>
            {newTradeData &&
              newTradeData?.paymentHistory?.totalPaidAmount[
                transactionConstants.CASH
              ] > 0 && (
                <div className="d-flex w-100 justify-content-between align-items-center mt-3 pt-2 border-top">
                  <div className="d-flex align-items-center gap-2">
                    <span className="subtotal-heading">Cash</span>
                  </div>
                  <span className="payment-cart-productname">
                    $
                    {Number(
                      newTradeData?.paymentHistory?.totalPaidAmount[
                        transactionConstants.CASH
                      ]
                    ).toFixed(2)}
                  </span>
                </div>
              )}
            {newTradeData &&
              newTradeData?.paymentHistory?.totalPaidAmount[
                transactionConstants.STORE_CREDIT
              ] > 0 && (
                <div className="d-flex w-100 justify-content-between align-items-center mt-3 pt-2 border-top">
                  <div className="d-flex align-items-center gap-2">
                    <span className="subtotal-heading">Store Credit</span>
                  </div>
                  <span className="payment-cart-productname">
                    $
                    {Number(
                      newTradeData?.paymentHistory?.totalPaidAmount[
                        transactionConstants.STORE_CREDIT
                      ]
                    ).toFixed(2)}
                  </span>
                </div>
              )}
            {newTradeData &&
              newTradeData?.paymentHistory?.totalPaidAmount[
                transactionConstants.OTHER
              ] > 0 && (
                <div className="d-flex w-100 justify-content-between align-items-center mt-3 pt-2 border-top">
                  <div className="d-flex align-items-center gap-2">
                    <span className="subtotal-heading">Other</span>
                  </div>
                  <span className="payment-cart-productname">
                    $
                    {Number(
                      newTradeData?.paymentHistory?.totalPaidAmount[
                        transactionConstants.OTHER
                      ]
                    ).toFixed(2)}
                  </span>
                </div>
              )}
          </div>
        </Col>

        <Col md={6}>
          {newTradeData?.paymentMethod ===
          transactionConstants.PAYMENT_COMPLETE ? (
            <div className="payment-div-wrapper">
              <Row className="m-0 w-100">
                <Col md={12}>
                  <TradePaymentComplete
                    newTradeData={newTradeData}
                    handleClick={() => {}}
                    setNewTradeData={updateTradeData}
                    selectedCustomer={newTradeData?.customer}
                    handlePrintReceipt={handlePrintReceipt}
                    sendEmailOrSMS={sendEmailOrSMS}
                    handleShowDraftModal={handleShowDraftModal}
                    handleAddCustomerClick={handleAddCustomerClick}
                  />
                </Col>
              </Row>
            </div>
          ) : (
            <>
              <div className="payment-div-wrapper mb-3">
                <Row className="m-0 w-100">
                  {newTradeData?.customer?.name !== "" &&
                  newTradeData?.customer?.name !== null ? (
                    <Col md={12} className="mt-1">
                      <SelectedCustomerCard
                        customer={newTradeData?.customer}
                        isStoreCredit={true}
                        isDeleteEditOptions={true}
                        handleCustomerDeleteClick={() => {
                          updateTradeData(
                            {
                              ...newTradeData,
                              PaymentType: globalConstants.CASH,
                              customer: { id: "", name: "" },
                            },
                            SALE_TRANSACTION_ACTIVITY_TYPES.DELETE_CUSTOMER
                          );
                        }}
                        handleAddCustomerClick={handleAddCustomerClick}
                        handleCustomerEditClick={handleCustomerEditClick}
                      />
                    </Col>
                  ) : (
                    <>
                      <Col
                        md={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <span className="amount-to-pay-heading">
                          Select a Customer
                        </span>
                      </Col>
                      <Col md={12} className="mt-1 mb-3">
                        <CustomerDropdown
                          handleChange={(selectedOption) => {
                            updateTradeData(
                              {
                                ...newTradeData,
                                customer: selectedOption?.value
                                  ? parseJsonObject(selectedOption?.value)
                                  : { id: "", name: "" },
                              },
                              SALE_TRANSACTION_ACTIVITY_TYPES.ADD_CUSTOMER
                            );
                          }}
                          value={
                            newTradeData?.customer?.id
                              ? {
                                  value: stringifyObject(
                                    newTradeData?.customer
                                  ),
                                  label: (
                                    <div className="d-flex align-items-center gap-2 ">
                                      <span>
                                        <img
                                          src={CustomerImage}
                                          className="new-sale-customer-image"
                                          alt="customer"
                                        />
                                      </span>
                                      {`${newTradeData?.customer.firstName} ${newTradeData?.customer.lastName}`}
                                    </div>
                                  ),
                                }
                              : ""
                          }
                          isLockCustomer={false}
                          isGuestCustomers={true}
                          SelectIconImage={
                            categoryDropdownConstants.SEARCH_ICON
                          }
                          dropdownIndicator={false}
                          handleAddCustomerClick={handleAddCustomerClick}
                          selectedCustomerFlag={selectedCustomerFlag}
                          menuPortalTarget={""}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
              <div className="payment-div-wrapper">
                <Row className="m-0 w-100">
                  <>
                    <Col
                      md={12}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span className="amount-to-pay-heading-trade">
                        Payout
                      </span>
                      <span className="amount-to-pay-detail-trade">
                        Type:{" "}
                        <span>{`${
                          isSplitPayment
                            ? transactionConstants.SPLIT_LABEL
                            : isCashPayment
                            ? isOtherPayment
                              ? transactionConstants.OTHER_LABEL
                              : transactionConstants.CASH_LABEL
                            : transactionConstants.STORE_CREDIT_LABEL
                        }`}</span>
                      </span>
                    </Col>

                    {isSplitPayment && (
                      <>
                        <Col
                          md={8}
                          className="d-flex flex-column align-items-end mt-2"
                        >
                          <span className="amount-to-pay-sub-heading-trade">
                            {`${
                              isCashPayment
                                ? isOtherPayment
                                  ? transactionConstants.OTHER_LABEL
                                  : transactionConstants.CASH_LABEL
                                : transactionConstants.STORE_CREDIT_LABEL
                            } :`}
                          </span>
                          <span className="">
                            Enter up to{" "}
                            <span className="fw-bold">
                              {" "}
                              {`$${parseToThousandSeperatorDecimalNumber(
                                splitAmounts.otherAmountToAdjust
                              )}`}
                            </span>
                          </span>
                        </Col>
                        <Col
                          md={4}
                          className="d-flex justify-content-end align-items-center amount-to-pay-detail-trade mt-2"
                        >
                          <SimpleNumberField
                            className="split-number-field"
                            value={splitAmounts.otherSplitAmount}
                            onChange={(value) => {
                              handleSplitValueChange(
                                value,
                                "otherSplitAmount",
                                true
                              );
                            }}
                            maxValue={Number(splitAmounts.otherAmountToAdjust)}
                            IconImage={DollarIcon}
                          />
                        </Col>
                        <Col
                          md={8}
                          className="d-flex flex-column align-items-end mt-2"
                        >
                          <span className="amount-to-pay-sub-heading-trade">
                            {`${
                              isCashPayment
                                ? transactionConstants.STORE_CREDIT_LABEL
                                : isOtherPayment
                                ? transactionConstants.OTHER_LABEL
                                : transactionConstants.CASH_LABEL
                            } :`}
                          </span>
                          <span className="">
                            Enter up to{" "}
                            <span className="fw-bold">
                              {" "}
                              {`$${parseToThousandSeperatorDecimalNumber(
                                splitAmounts.amountToAdjust
                              )}`}
                            </span>
                          </span>
                        </Col>
                        <Col
                          md={4}
                          className="d-flex justify-content-end align-items-center amount-to-pay-detail-trade mt-2"
                        >
                          <SimpleNumberField
                            className="split-number-field"
                            value={splitAmounts.splitAmount}
                            onChange={(value) => {
                              handleSplitValueChange(value);
                            }}
                            maxValue={Number(splitAmounts.amountToAdjust)}
                            IconImage={DollarIcon}
                          />
                        </Col>
                      </>
                    )}
                    {(isSplitPayment || isCashPayment) && (
                      <Col
                        md={12}
                        className="d-flex justify-content-end  mt-4 mb-3"
                      >
                        <span className="checkbox-field-text ms-1">
                          Use Other Payment Method
                        </span>
                        <input
                          className="checkbox-field ms-2"
                          type="checkbox"
                          checked={isOtherPayment}
                          onChange={() => toggleIsOtherPayment(!isOtherPayment)}
                        />
                      </Col>
                    )}
                    <Col
                      md={12}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <button
                        className="trade-split-button"
                        onClick={() => {
                          handleCancelSplitPayout();
                        }}
                      >{`${
                        isSplitPayment ? "Cancel Split Payout" : "Split Payout?"
                      }`}</button>
                    </Col>
                    <Col md={12} className="d-flex mt-3 ">
                      <div className="receiptTotal w-100">
                        <p className="receiptTotal-heading mb-0">
                          Payout Summary
                        </p>
                        <p className="receiptTotal-amount mb-0 mt-2">
                          $
                          {parseToThousandSeperatorDecimalNumber(
                            newTradeData?.totalAmountToPay
                          )}
                          {isSplitPayment
                            ? isOtherPayment
                              ? ` (${transactionConstants.OTHER_LABEL} / ${transactionConstants.STORE_CREDIT_LABEL})`
                              : ` (${transactionConstants.CASH_LABEL} / ${transactionConstants.STORE_CREDIT_LABEL})`
                            : isCashPayment
                            ? isOtherPayment
                              ? ` (${transactionConstants.OTHER_LABEL})`
                              : ` (${transactionConstants.CASH_LABEL})`
                            : ` (${transactionConstants.STORE_CREDIT_LABEL})`}
                        </p>
                      </div>
                    </Col>
                    {(isSplitPayment || !isCashPayment) && (
                      <>
                        <Col md={12} className="d-flex mt-4 mb-3">
                          <input
                            className="checkbox-field"
                            type="checkbox"
                            checked={isConsent}
                            onChange={() => setIsConsent(!isConsent)}
                          />
                          <span className="checkbox-field-text ms-1">
                            Customer read and agree with terms of trade credit
                          </span>
                        </Col>
                      </>
                    )}
                    <Col md={12} className="d-flex mt-3 align-items-end gap-2">
                      {isTradeInProgress(spinnerArray) ? (
                        <Button
                          type="button"
                          className="w-50 mx-auto"
                          buttonType={buttonTypeConstants.LOADING_BUTTON}
                        />
                      ) : (
                        <>
                          <Button
                            label={buttonNameConstants.BACK}
                            className="w-100"
                            type="button"
                            handleClick={() => getBackNavigation()}
                            buttonType={buttonTypeConstants.GHOST_BUTTON}
                          />
                          <Button
                            label={buttonNameConstants.COMPLETE}
                            className="w-100"
                            type="button"
                            handleClick={submitAddTradeTransaction}
                          />
                        </>
                      )}
                    </Col>
                  </>
                </Row>
              </div>
            </>
          )}
        </Col>

        <ConfirmationModal
          isConfirmationModal={isConfirmationModal}
          handleNoButtonClick={handleConfirmNoButtonClick}
          handleYesButtonClick={handleConfirmYesButtonClick}
          toggleConfirmationModal={toggleConfirmationModal}
          yesButtonText={buttonNameConstants.CONTINUE}
          noButtonText={buttonNameConstants.CANCEL}
          message={"Use your Other payment source to provide payment."}
        />
        <TradePrintLabelModal
          printLabelModal={printLabelModal}
          togglePrintLabelModal={togglePrintLabelModal}
          selectedRows={selectedRows}
          labelNotifications={labelNotifications}
        />
        {addCustomerModal && (
          <AddNewCustomerModal
            selectedCustomer={selectedCustomer}
            addCustomerModal={addCustomerModal}
            customerToEdit={customerToEdit}
          />
        )}
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  outlet: state.outlet,
  printer: state.printer,
  customer: state.customer,
  transaction: state.transaction,
  user: state.authentication.user,
  company: state.authentication.company,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  userNotifications: state.store.userNotifications,
  isAddCustomerModal: state.transaction.isAddCustomerModal,
  addTradeBatchInventory: state.transaction.addTradeBatchInventory,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  sendEmailOrSMS: (data) => dispatch(transactionActions.sendEmailOrSMS(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  setNewTradeData: (data, storeId) =>
    dispatch(transactionActions.setNewTradeData(data, storeId)),
  toggleAddCustomerModal: (value) =>
    dispatch(transactionActions.toggleAddCustomerModal(value)),
  handleDraftModal: (isToggle) =>
    dispatch({
      type: transactionConstants.SET_DRAFT_CONFIRMATION,
      data: isToggle,
    }),
  getOutletByMacAddress: (storeId, macAddress) =>
    dispatch(outletActions.getOutletByMacAddress(storeId, macAddress)),
  newTradePark: (data, storeId) =>
    dispatch(transactionActions.newTradePark(data, storeId)),
  handleOpenCashDrawer,
  tradeTransaction: (
    data,
    companyId,
    newTradeData,
    updateTradeData,
    handlePrintReceipt,
    isAutoPrintReceipt,
    handleOpenCashDrawer,
    defaultReceiptPrinter
  ) =>
    dispatch(
      transactionActions.tradeTransaction(
        data,
        companyId,
        newTradeData,
        updateTradeData,
        handlePrintReceipt,
        isAutoPrintReceipt,
        handleOpenCashDrawer,
        defaultReceiptPrinter
      )
    ),
});

//-------Export transaction Component
export default connect(mapStateToProps, mapDispatchToProps)(NewTradePayment);
